import React from "react";
import { Card, Form, Input, Button, Modal, Select, message, DatePicker, Table as AntTable, Tag, Icon, Spin, Tooltip, Row as AntRow, Col as AntCol } from "antd";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { Row, Col, FormGroup, Label, Table, Spinner } from 'reactstrap';
import Media from 'react-media';

//import filterFactory from 'react-bootstrap-table2-filter';
///import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

import 'moment/locale/fr-ca';
//import locale from 'antd/es/date-picker/locale/fr_FR';

import { services } from '../../../services/services';
import { authenticationService } from "../../../services/authentication-service";
//import { use_logiciel } from '../../../env';

import { numberWithCommas } from '../../../helpers/index';

const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;

const currentUser = authenticationService.currentUserValue;

//const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];

//const confirm = Modal.confirm;

const FormItem = Form.Item;

const moment = require('moment')

class DetailsFactures extends React.Component {
    state = {
        isModalVisible: false,
        isAddModalVisible: false,
        isUpdateModalVisible: false,
        loading: false,
        isListArticleVisible: false,
        isDetailsArticleVisible: false,
        isValidationValidation: false,
        repartitions: [],
        listeArticlesSelected: [],
        articles: [],
        articlesCodPro: [],
        formLayout: 'horizontal',

        usuel: "1",
        codTyp: "1",
        libCat: '',
        codeCat: '',
        emailFour: '',
        refFactFour: '',
        codAgence: '',
        modRegl: '',
        codmod: '',
        tauxAib: 0,
        fraisTransport: 0,
        cleRepartition: 0,
        dateFact: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
        dateEnCours: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
        startDate: moment(),
        endDate: moment(),
        refFact: '',
        etatCmde: 'EN COURS',
        puRemise: 0,
        autreFrais: 0,
        montantRemise: 0,
        //puRemise: 0,
        qtCommander: 0,

        factures: [],
        clients: [],
        //agences: [],
        gender: 'M',
        raisonSociale: '',
        codClient: '',
        mentionClient: 'NOUVEAU CLIENT',
        typeClient: 'CLIENT ORDINAIRE',
        //usuel: '1',
        dateNaissance: moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
        ifu: '',
        observation: '',
        numeroCarte: '',

        waitingEndMsg: '',
        isLoading: true,
        agences: [],
        searchText: '',
        numFact: '',
        montFact: 0
    }

    handleSearch = (e) => {
        this.setState({ searchText: e.target.value })
    }

    handleRefresh = () => {
        const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        this.setState({ isLoading: true, factures: [] });
        services.getDetailsFactures(this.state.dateEnCours, startDate, endDate, this.state.codAgence)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false });
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: "Vous n'avez aucune Facture pour cette période!" });
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false });
                message.error(err, 10);
            });
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    componentDidMount() {
        const startDate = moment(new Date(), 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(new Date(), 'DD/MM/YYYY').format('YYYY-MM-DD')

        services.getDetailsFactures(this.state.dateEnCours, startDate, endDate, this.state.codAgence)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false })
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: `Vous n'avez aucune Facture actuellement pour la date du ${this.state.dateEnCours}!` })
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false })
                message.error(err, 10)
            });

        services.getAllAgences()
            .then(agences => {
                this.setState({ agences: agences || [] })
            })
    }

    handleChangeAgence = (value) => {
        this.setState({ codAgenceChange: value, codAgence: value, isLoading: true, waitingEndMsg: '', factures: [] })

        const startDate = moment(this.state.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(this.state.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
        services.getDetailsFactures(this.state.dateEnCours, startDate, endDate, value)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false })
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: `Vous n'avez aucune Facture actuellement pour cette Agence!` })
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false })
                message.error(err, 10)
            });
    }

    onDateChange = (date, dateString) => {
        this.setState({ isLoading: true, factures: [] })

        const startDate = moment(dateString[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
        const endDate = moment(dateString[1], 'DD/MM/YYYY').format('YYYY-MM-DD')

        services.getDetailsFactures(this.state.dateEnCours, startDate, endDate, this.state.codAgence)
            .then(factures => {
                this.setState({ factures: factures || [], isLoading: false })
                if (!factures || !Array.isArray(factures) || factures.length === 0) {
                    this.setState({ waitingEndMsg: `Vous n'avez aucune Facture actuellement pour cette Agence!` })
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false })
                message.error(err, 10)
            });
        this.setState({ startDate: dateString[0], endDate: dateString[1] })
    }


    handleView = (row) => {
        const targetNumFact = row.numFact || (row.facture && row.facture.numFact) || '';
        
        let invoiceArticles = [];
        if (row.listeArticlesSelected && row.listeArticlesSelected.length) {
            invoiceArticles = row.listeArticlesSelected;
        } else if (this.state.factures && this.state.factures.length && targetNumFact) {
            invoiceArticles = this.state.factures.filter(f => (f.numFact === targetNumFact) || (f.facture && f.facture.numFact === targetNumFact));
        }
        if (!invoiceArticles.length) {
            invoiceArticles = [row];
        }

        const formattedArticles = invoiceArticles.map((details) => {
            const puBrut = parseFloat(details.puBrut || details.puUtilise || 0);
            const puRemise = parseFloat(details.puRemise || 0);
            const puUtilise = parseFloat(details.puUtilise || (puBrut - puRemise) || 0);
            const qt = parseFloat(details.qtCommander || 1);
            const tauxTva = parseFloat(details.tauxTva || 0);
            return {
                puRemise: puRemise,
                qtCommander: qt,
                codTva: details.codTva,
                tauxTva: tauxTva,
                puAchat: details.puAchat || (puBrut - puRemise),
                puBrut: puBrut,
                puUtilise: puUtilise,
                codAgence: details.codAgence || (row.agences && row.agences.codAgence) || '',
                designation: (details.article && details.article.designation) || details.designation || '',
                codProd: (details.article && details.article.codPro) || details.codProd || '',
            };
        });

        const f = row.facture || {};
        const agenceObj = row.agences || f.agences || {};
        const clientObj = row.clients || f.clients || {};
        const userObj = row.userInfo || f.userInfo || {};

        const nomAgent = userObj.prenomAgent 
            ? `${userObj.prenomAgent} ${userObj.nomAgent || ''}`.trim()
            : `${userObj.firstName || ''} ${userObj.lastName || ''}`.trim();

        const nomAgence = agenceObj.nomAgence || row.nomAgence || f.nomAgence || '';
        const clientName = clientObj.raisonSociale || row.raisonSociale || f.raisonSociale || '';
        const codClient = clientObj.codClient || f.codClient || row.codClient || '';

        const calculatedNetHT = formattedArticles.reduce((p, c) => p + (c.puUtilise * c.qtCommander), 0);
        const calculatedTotalTva = formattedArticles.reduce((p, c) => p + ((c.puUtilise * c.qtCommander * c.tauxTva) / 100), 0);
        const calculatedMontantRemise = formattedArticles.reduce((p, c) => p + (c.puRemise * c.qtCommander), 0);

        const netHT = parseFloat(f.netHT || row.netHT || calculatedNetHT || 0);
        const montantRemise = parseFloat(f.montantRemise || row.montantRemise || calculatedMontantRemise || 0);
        const netCommercial = parseFloat(f.netCommercial || row.netCommercial || (netHT - montantRemise) || 0);
        const totalTva = parseFloat(f.totalTva || row.totalTva || calculatedTotalTva || 0);
        const montantTtc = parseFloat(f.montantTtc || row.montantTtc || (netCommercial + totalTva) || 0);
        const tauxAib = parseFloat(f.tauxAib || f.tauxAIB || row.tauxAib || 0);
        const montantAib = parseFloat(f.montantAib || row.montantAib || ((tauxAib * montantTtc) / 100) || 0);
        const netaPayer = parseFloat(f.netaPayer || row.netaPayer || f.montFact || row.montFact || (montantTtc + montantAib) || 0);
        const montFact = parseFloat(f.montFact || row.montFact || netaPayer || 0);

        this.setState({
            isModalVisible: true,
            numFact: targetNumFact,
            dateFact: row.dateFact || f.dateFact || '',
            codClient: codClient,
            clientName: clientName,
            observation: row.observation || f.observation || '',
            modRegl: row.modRegl || f.modRegl || 'Cash',
            codmod: row.codmod || f.codmod || 'ESPECES',
            montantRemise: montantRemise,
            fraisTransport: parseFloat(row.fraisTransport || f.fraisTransport || 0),
            autreFrais: parseFloat(row.autreFrais || f.autreFrais || 0),
            tauxAib: tauxAib,
            totalTva: totalTva,
            netHT: netHT,
            tauxRemise: parseFloat(row.tauxRemise || f.tauxRemise || 0),
            netCommercial: netCommercial,
            montantTtc: montantTtc,
            montantAib: montantAib,
            netaPayer: netaPayer,
            montFact: montFact,
            refFact: row.refFact || f.refFact || '',
            nomAgence: nomAgence,
            nomAgent: nomAgent,
            listeArticlesSelected: formattedArticles,
        });
    };

    handleCancel = () => {
        this.setState({
            isModalVisible: false,
            dateRepartition: '',
            observation: '',
            codAgence: '',

            listeArticlesSelected: [],
        });
    }


    handleChangeDateFiltre = (date, dateString) => {
        ////console.log(dateString, moment(dateString).format('DD/MM/YYYY'), moment(date, dateFormatList[0]));
        this.setState({ dateEnCours: dateString })
        this.setState({ isLoading: true, waitingEndMsg: '' })
        services.getDetailsFactures(dateString)
            .then(factures => {
                //console.log('Details factures', factures)
                this.setState({ factures })

                setTimeout(() => {

                    // //console.log("real articles", factures)
                    if (!factures || !Array.isArray(factures)
                        || !factures.length > 0) {
                        this.setState({ isLoading: false, waitingEndMsg: `Vous n'avez aucune Facture actuellement pour la date du ${this.state.dateEnCours}!` })
                    }
                }, 500)
            })
            .catch((err) => {
                message.error(err, 10)
            });
    }


    render() {
        const {
            isModalVisible,
            //loading,

            // dateEnCours,
            dateFact,
            observation,
            //codAgence,
            modRegl,
            // montantAp,
            codmod,
            refFact,
            //qtCommander,
            // puRemise,
            // puBrut,
            // puUtilise,


            //etatCmde,
            // numPoint,
            // valider,
            // datValid,

            fraisTransport,
            listeArticlesSelected,
            // articles,

            // repartitions,
            //  qteStockEnCoursValidation,



            // isAddClientModalVisible,
            // isAddModalVisible,
            // isUpdateModalVisible,
            // isListArticleVisible,
            //  isDetailsArticleVisible,
            // isValidationValidation,

            // qtEntree,

            codClient,
            //  raisonSociale,
            //  ifu,
            // adresse,
            //  contact,
            // contact2,
            /// gender,
            // usuel,
            // dateNaissance,
            //  typeClient,
            // siteWeb,
            // email,
            //  profession,
            //  mentionClient,
            //  numeroCarte,
            clients,

            factures,

            // qteStock,

            formLayout,

            tauxAib,
            //montantAib,
            //montantTtc,
            //netCommercial,
            //tauxRemise,
            montantRemise,
            autreFrais, //n'existe pas

            nomAgence,
            nomAgent,

            //designation,

            isLoading,
            waitingEndMsg,

            codAgenceChange,
            agences,
            startDate,
            endDate,
            searchText,
            numFact,
            montFact,
            clientName,
        } = this.state

        const nbresArticles = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce((prev, cur) => prev + parseFloat(cur.qtCommander || 0), 0) : 0;

        const totalTva = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce((prev, cur) => prev + parseFloat((cur.puUtilise * cur.qtCommander * (cur.tauxTva || 0)) / 100), 0)
            : parseFloat(this.state.totalTva || 0);

        const netHT = listeArticlesSelected && listeArticlesSelected.length ?
            listeArticlesSelected.reduce((prev, cur) => prev + parseFloat(cur.puUtilise * cur.qtCommander), 0)
            : parseFloat(this.state.netHT || 0);

        const netCommercial = netHT > 0 ? (parseFloat(netHT) - parseFloat(montantRemise || 0)) : parseFloat(this.state.netCommercial || this.state.netHT || 0);
        const montantTtc = netHT > 0 ? (parseFloat(netCommercial) + parseFloat(totalTva) + parseFloat(fraisTransport || 0) + parseFloat(autreFrais || 0)) : parseFloat(this.state.montantTtc || this.state.montFact || 0);
        const montantAib = ((parseFloat(tauxAib || 0) * montantTtc) / 100);
        const netaPayer = montantTtc > 0 ? (parseFloat(montantTtc) + parseFloat(montantAib)) : parseFloat(this.state.netaPayer || this.state.montFact || 0);

        const Option = Select.Option;

        let totalChiffre = factures && factures.length ?
            factures.reduce(function (prev, cur) {
                return prev + (parseFloat(cur.puUtilise || 0) * parseFloat(cur.qtCommander || 0))
            }, 0) : 0;

        let totalQte = factures && factures.length ?
            factures.reduce(function (prev, cur) {
                return prev + parseFloat(cur.qtCommander || 0)
            }, 0) : 0;

        let totalLignes = factures && factures.length ? factures.length : 0;
        let panierMoyenLigne = totalLignes ? Math.round(totalChiffre / totalLignes) : 0;

        const search = (searchText || '').toLowerCase().trim();
        const filteredFactures = (factures || []).filter(item => {
            if (!search) return true;
            const numFactStr = (item.numFact || '').toString().toLowerCase();
            const articleStr = (item.article && item.article.designation || item.designation || '').toLowerCase();
            const clientStr = (item.clients && item.clients.raisonSociale || item.raisonSociale || '').toLowerCase();
            const contactStr = (item.clients && item.clients.contact || item.contact || '').toLowerCase();
            const agenceStr = (item.agences && item.agences.nomAgence || item.nomAgence || '').toLowerCase();
            const agentStr = (item.userInfo ? `${item.userInfo.prenomAgent || ''} ${item.userInfo.nomAgent || ''}` : '').toLowerCase();
            const imeiStr = (item.observation || '').toLowerCase();
            const dateStr = item.dateFact ? moment(new Date(item.dateFact)).format('DD/MM/YYYY') : '';

            return numFactStr.includes(search) ||
                articleStr.includes(search) ||
                clientStr.includes(search) ||
                contactStr.includes(search) ||
                agenceStr.includes(search) ||
                agentStr.includes(search) ||
                imeiStr.includes(search) ||
                dateStr.includes(search);
        });

        const columnsFactures = [
            {
                title: 'Fact N°',
                dataIndex: 'numFact',
                key: 'numFact',
                width: 110,
                sorter: (a, b) => (a.numFact || '').localeCompare(b.numFact || ''),
                render: (val, record) => (
                    <span
                        onClick={() => this.handleView(record)}
                        style={{
                            fontWeight: 700,
                            color: '#1890ff',
                            fontFamily: 'monospace',
                            cursor: 'pointer',
                            display: 'inline-block'
                        }}
                        title="Cliquer pour voir les détails"
                    >
                        #{val || '-'}
                    </span>
                )
            },
            {
                title: 'Désignation',
                dataIndex: 'article.designation',
                key: 'designation',
                width: 230,
                render: (val, record) => (
                    <span style={{ fontWeight: 600, color: '#262626' }}>
                        {record.article && record.article.designation ? record.article.designation : record.designation || '-'}
                    </span>
                )
            },
            {
                title: 'Date',
                dataIndex: 'dateFact',
                key: 'dateFact',
                width: 110,
                align: 'center',
                sorter: (a, b) => new Date(a.dateFact || 0) - new Date(b.dateFact || 0),
                render: (val, record) => (
                    <span style={{ color: '#595959', whiteSpace: 'nowrap' }}>
                        {record.dateFact ? moment(new Date(record.dateFact)).format('DD/MM/YYYY') : '-'}
                    </span>
                )
            },
            {
                title: 'Heure Création',
                dataIndex: 'createdAt',
                key: 'createdAt',
                width: 120,
                align: 'center',
                render: (val, record) => {
                    if (record.heure) return <span style={{ color: '#8c8c8c' }}>{record.heure}</span>;
                    if (!val) return <span style={{ color: '#bfbfbf' }}>-</span>;
                    const date = new Date(parseInt(val));
                    const options = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
                    return <span style={{ color: '#8c8c8c' }}>{date.toLocaleString('fr-FR', options)}</span>;
                }
            },
            {
                title: 'PU Brut',
                dataIndex: 'puBrut',
                key: 'puBrut',
                width: 120,
                align: 'right',
                render: (val) => (
                    <span style={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                        {numberWithCommas(parseFloat(val || 0))} F
                    </span>
                )
            },
            {
                title: 'Montant Remise',
                dataIndex: 'puRemise',
                key: 'puRemise',
                width: 130,
                align: 'right',
                render: (val) => {
                    const r = parseFloat(val || 0);
                    return r > 0 ? (
                        <Tag color="orange" style={{ fontWeight: 600 }}>-{numberWithCommas(r)} F</Tag>
                    ) : (
                        <span style={{ color: '#bfbfbf' }}>0</span>
                    );
                }
            },
            {
                title: 'PU Net TTC',
                dataIndex: 'puAchat',
                key: 'puAchat',
                width: 120,
                align: 'right',
                render: (val, record) => {
                    const puNet = parseFloat(record.puBrut || 0) - parseFloat(record.puRemise || 0);
                    return (
                        <span style={{ fontWeight: 600, color: '#13c2c2', whiteSpace: 'nowrap' }}>
                            {numberWithCommas(puNet)} F
                        </span>
                    );
                }
            },
            {
                title: 'Qté Commandée',
                dataIndex: 'qtCommander',
                key: 'qtCommander',
                width: 130,
                align: 'center',
                sorter: (a, b) => parseFloat(a.qtCommander || 0) - parseFloat(b.qtCommander || 0),
                render: (val) => (
                    <Tag color="blue" style={{ fontWeight: 700, fontSize: 13, padding: '2px 8px' }}>
                        {numberWithCommas(parseFloat(val || 0))}
                    </Tag>
                )
            },
            {
                title: 'Montant TTC',
                dataIndex: 'codProd',
                key: 'codProd',
                width: 140,
                align: 'right',
                sorter: (a, b) => (parseFloat(a.puUtilise || 0) * parseFloat(a.qtCommander || 0)) - (parseFloat(b.puUtilise || 0) * parseFloat(b.qtCommander || 0)),
                render: (val, record) => {
                    const totalLigne = parseFloat(record.puUtilise || 0) * parseFloat(record.qtCommander || 0);
                    return (
                        <span style={{ fontWeight: 700, color: '#52c41a', whiteSpace: 'nowrap' }}>
                            {numberWithCommas(totalLigne)} F
                        </span>
                    );
                }
            },
            {
                title: 'TVA',
                dataIndex: 'tauxTva',
                key: 'tauxTva',
                width: 90,
                align: 'center',
                render: (val) => (
                    <Tag color={parseFloat(val || 0) > 0 ? "volcano" : "default"}>
                        {val ? `${val}%` : '0%'}
                    </Tag>
                )
            },
            {
                title: 'Agents',
                dataIndex: 'userInfo',
                key: 'userInfo',
                width: 160,
                render: (val, record) => (
                    <span style={{ whiteSpace: 'nowrap' }}>
                        {record.userInfo ? `${record.userInfo.prenomAgent || ''} ${record.userInfo.nomAgent || ''}` : '-'}
                    </span>
                )
            },
            {
                title: 'Agence',
                dataIndex: 'agences.nomAgence',
                key: 'nomAgence',
                width: 140,
                render: (val, record) => (
                    <Tag color="geekblue">
                        {record.agences ? record.agences.nomAgence : record.nomAgence || '-'}
                    </Tag>
                )
            },
            {
                title: 'Client',
                dataIndex: 'clients.raisonSociale',
                key: 'client',
                width: 180,
                render: (val, record) => (
                    <span style={{ fontWeight: 600, color: '#1f1f1f' }}>
                        {record.clients ? record.clients.raisonSociale : record.raisonSociale || 'Client Ordinaire'}
                    </span>
                )
            },
            {
                title: 'Contact',
                dataIndex: 'clients.contact',
                key: 'contact',
                width: 130,
                render: (val, record) => (
                    <span style={{ color: '#595959', fontFamily: 'monospace' }}>
                        {record.clients ? record.clients.contact : record.contact || '-'}
                    </span>
                )
            },
            {
                title: 'Imei',
                dataIndex: 'observation',
                key: 'observation',
                width: 140,
                render: (val) => (
                    <span style={{ color: '#8c8c8c', fontSize: 12 }}>
                        {val || '-'}
                    </span>
                )
            },
            {
                title: 'Action',
                key: 'action',
                width: 80,
                align: 'center',
                fixed: 'right',
                render: (text, record) => (
                    <Tooltip title="Visualiser la facture">
                        <Button
                            type="primary"
                            size="small"
                            shape="circle"
                            icon="eye"
                            onClick={() => this.handleView(record)}
                        />
                    </Tooltip>
                )
            }
        ];

        return (
            <div>
                {/* 4 CARTES KPI STATISTIQUES */}
                <AntRow gutter={[16, 16]} style={{ marginBottom: 20 }}>
                    <AntCol xs={24} sm={12} lg={6}>
                        <div style={{
                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                            borderRadius: 10,
                            padding: '16px 18px',
                            color: '#fff',
                            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.25)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{ minWidth: 0, flex: 1, paddingRight: 6 }}>
                                <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Chiffre d'Affaires Global</div>
                                <div style={{ fontSize: 20, fontWeight: 700, marginTop: 4, whiteSpace: 'nowrap' }}>
                                    {numberWithCommas(Math.round(totalChiffre))} F CFA
                                </div>
                                <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Total des ventes</div>
                            </div>
                            <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <Icon type="dollar" style={{ fontSize: 20, color: '#fff' }} />
                            </div>
                        </div>
                    </AntCol>
                    <AntCol xs={24} sm={12} lg={6}>
                        <div style={{
                            background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
                            borderRadius: 10,
                            padding: '16px 18px',
                            color: '#fff',
                            boxShadow: '0 4px 12px rgba(82, 196, 26, 0.25)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{ minWidth: 0, flex: 1, paddingRight: 6 }}>
                                <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Quantité Vendue</div>
                                <div style={{ fontSize: 20, fontWeight: 700, marginTop: 4, whiteSpace: 'nowrap' }}>
                                    {numberWithCommas(Math.round(totalQte))} unités
                                </div>
                                <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Articles commandés</div>
                            </div>
                            <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <Icon type="shopping-cart" style={{ fontSize: 20, color: '#fff' }} />
                            </div>
                        </div>
                    </AntCol>
                    <AntCol xs={24} sm={12} lg={6}>
                        <div style={{
                            background: 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)',
                            borderRadius: 10,
                            padding: '16px 18px',
                            color: '#fff',
                            boxShadow: '0 4px 12px rgba(250, 140, 22, 0.25)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{ minWidth: 0, flex: 1, paddingRight: 6 }}>
                                <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Lignes Vendues</div>
                                <div style={{ fontSize: 20, fontWeight: 700, marginTop: 4, whiteSpace: 'nowrap' }}>
                                    {numberWithCommas(totalLignes)} lignes
                                </div>
                                <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Transactions détaillées</div>
                            </div>
                            <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <Icon type="profile" style={{ fontSize: 20, color: '#fff' }} />
                            </div>
                        </div>
                    </AntCol>
                    <AntCol xs={24} sm={12} lg={6}>
                        <div style={{
                            background: 'linear-gradient(135deg, #722ed1 0%, #531dab 100%)',
                            borderRadius: 10,
                            padding: '16px 18px',
                            color: '#fff',
                            boxShadow: '0 4px 12px rgba(114, 46, 209, 0.25)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{ minWidth: 0, flex: 1, paddingRight: 6 }}>
                                <div style={{ fontSize: 11, opacity: 0.85, textTransform: 'uppercase', letterSpacing: 0.5 }}>Moyenne / Ligne</div>
                                <div style={{ fontSize: 20, fontWeight: 700, marginTop: 4, whiteSpace: 'nowrap' }}>
                                    {numberWithCommas(panierMoyenLigne)} F CFA
                                </div>
                                <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>Panier moyen article</div>
                            </div>
                            <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 8, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <Icon type="calculator" style={{ fontSize: 20, color: '#fff' }} />
                            </div>
                        </div>
                    </AntCol>
                </AntRow>

                <Card
                    title={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Icon type="ordered-list" style={{ color: '#1890ff', fontSize: 20, marginRight: 8 }} />
                                <span style={{ fontWeight: 700, fontSize: 17, color: '#1f1f1f' }}>
                                    Détails des Factures
                                </span>
                            </div>
                            <Tag color="blue" style={{ fontWeight: 600, fontSize: 13, padding: '2px 10px' }}>
                                {numberWithCommas(filteredFactures.length)} enregistrement{filteredFactures.length > 1 ? 's' : ''}
                            </Tag>
                        </div>
                    }
                    bordered={false}
                    className="gx-card"
                >
                    {/* BARRE DE FILTRES ET ACTIONS */}
                    <div style={{
                        background: '#fafafa',
                        border: '1px solid #f0f0f0',
                        borderRadius: 8,
                        padding: '12px 16px',
                        marginBottom: 20,
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 12,
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center', flex: 1 }}>
                            <Input
                                prefix={<Icon type="search" style={{ color: '#bfbfbf' }} />}
                                placeholder="Rechercher par N°, article, client, agent, agence, imei..."
                                value={searchText}
                                onChange={this.handleSearch}
                                allowClear
                                style={{ width: 320, borderRadius: 6 }}
                            />
                            <RangePicker
                                style={{ borderRadius: 6 }}
                                defaultValue={[moment(startDate, dateFormat), moment(endDate, dateFormat)]}
                                format={dateFormat}
                                onChange={this.onDateChange}
                                ranges={{
                                    "Aujourd'hui": [moment(), moment()],
                                    'Cette Semaine': [moment().startOf('week'), moment().endOf('week')],
                                    'Ce Mois': [moment().startOf('month'), moment().endOf('month')],
                                    'Cette Année': [moment().startOf('year'), moment().endOf('year')]
                                }}
                            />
                            <Select
                                value={codAgenceChange}
                                showSearch
                                style={{ width: 200 }}
                                placeholder="Filtrer par Agence"
                                optionFilterProp="children"
                                onChange={this.handleChangeAgence}
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                <Option value=''>TOUTES LES AGENCES</Option>
                                {agences && agences.length ?
                                    agences.map((agence, k) => (
                                        <Option key={k} value={agence.codAgence}>{agence.nomAgence}</Option>
                                    )) : null
                                }
                            </Select>
                            <Button icon="reload" onClick={this.handleRefresh} loading={isLoading} style={{ borderRadius: 6 }}>
                                Actualiser
                            </Button>
                        </div>
                    </div>

                    {/* TABLEAU DES FACTURES */}
                    <AntTable
                        columns={columnsFactures}
                        dataSource={filteredFactures}
                        rowKey={(record, index) => record.id || `${record.numFact}_${record.codProd}_${index}`}
                        loading={isLoading}
                        pagination={{
                            defaultPageSize: 15,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '15', '25', '50', '100'],
                            showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} lignes`
                        }}
                        scroll={{ x: 1900 }}
                        bordered
                        size="middle"
                        locale={{
                            emptyText: waitingEndMsg || "Aucun enregistrement trouvé pour les critères sélectionnés"
                        }}
                    />
                </Card>

                {/* MODAL DETAILS DE LA FACTURE */}
                <Modal
                    width={950}
                    visible={isModalVisible}
                    title={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingRight: 24 }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Icon type="file-done" style={{ color: '#1890ff', fontSize: 20, marginRight: 8 }} />
                                <span style={{ fontWeight: 700, fontSize: 17, color: '#1f1f1f' }}>
                                    Détails Facture N° {numFact || '-'}
                                </span>
                            </div>
                            <Tag color="geekblue" style={{ fontFamily: 'monospace', fontWeight: 600, fontSize: 13, padding: '2px 10px' }}>
                                Réf: {refFact || '-'}
                            </Tag>
                        </div>
                    }
                    onOk={this.handleCancel}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="close" type="primary" onClick={this.handleCancel} style={{ borderRadius: 6, padding: '0 24px' }}>
                            Fermer
                        </Button>
                    ]}
                >
                    {/* EN-TETE INFOS CLIENT & FACTURE */}
                    <div style={{
                        background: '#fafafa',
                        border: '1px solid #f0f0f0',
                        borderRadius: 8,
                        padding: '16px 20px',
                        marginBottom: 20
                    }}>
                        <AntRow gutter={[16, 12]}>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Client</div>
                                <div style={{ fontSize: 14, fontWeight: 600, color: '#262626', marginTop: 2, display: 'flex', alignItems: 'center' }}>
                                    <Icon type="user" style={{ color: '#1890ff', marginRight: 6 }} />
                                    {clientName || (() => {
                                        const cObj = clients && clients.find(c => c.codClient === codClient || c.id === codClient);
                                        return cObj ? cObj.raisonSociale : codClient || 'Client Ordinaire';
                                    })()}
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Agence</div>
                                <div style={{ marginTop: 2 }}>
                                    <Tag color="blue" style={{ fontSize: 12 }}>{nomAgence || '-'}</Tag>
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Date d'émission</div>
                                <div style={{ fontSize: 13, fontWeight: 500, color: '#262626', marginTop: 2, display: 'flex', alignItems: 'center' }}>
                                    <Icon type="calendar" style={{ color: '#52c41a', marginRight: 6 }} />
                                    {dateFact ? moment(new Date(dateFact), 'DD/MM/YYYY').format('DD/MM/YYYY') : '-'}
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Agent / Caissier</div>
                                <div style={{ fontSize: 13, fontWeight: 500, color: '#262626', marginTop: 2 }}>
                                    {nomAgent || '-'}
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Règlement</div>
                                <div style={{ marginTop: 2 }}>
                                    <Tag color="green">{modRegl || 'Cash'}</Tag>
                                    <Tag color="cyan">{codmod || 'Espèces'}</Tag>
                                </div>
                            </AntCol>
                            <AntCol xs={24} sm={12} md={8}>
                                <div style={{ fontSize: 11, color: '#8c8c8c', textTransform: 'uppercase', fontWeight: 600 }}>Observation</div>
                                <div style={{ fontSize: 13, color: '#595959', marginTop: 2 }}>
                                    {observation || 'Aucune observation'}
                                </div>
                            </AntCol>
                        </AntRow>
                    </div>

                    {/* TABLEAU DES ARTICLES DE LA FACTURE */}
                    <div style={{ marginBottom: 20 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                            <span style={{ fontWeight: 700, fontSize: 14, color: '#262626' }}>
                                Articles de la commande
                            </span>
                            <Tag color="purple" style={{ fontWeight: 600 }}>
                                {nbresArticles} article{nbresArticles > 1 ? 's' : ''} au total
                            </Tag>
                        </div>
                        <AntTable
                            columns={[
                                { title: 'Code', dataIndex: 'codProd', key: 'codProd', width: 90, render: v => <span style={{ fontFamily: 'monospace', color: '#8c8c8c' }}>{v || '-'}</span> },
                                { title: 'Désignation', dataIndex: 'designation', key: 'designation', render: v => <span style={{ fontWeight: 600 }}>{v}</span> },
                                { title: 'PU Brut', dataIndex: 'puBrut', key: 'puBrut', align: 'right', render: v => `${numberWithCommas(parseFloat(v || 0))} F` },
                                {
                                    title: 'Remise', dataIndex: 'puRemise', key: 'puRemise', align: 'right',
                                    render: v => parseFloat(v || 0) > 0 ? <Tag color="orange">-{numberWithCommas(parseFloat(v))} F</Tag> : '-'
                                },
                                { title: 'PU Net HT', dataIndex: 'puUtilise', key: 'puUtilise', align: 'right', render: v => <span style={{ fontWeight: 600, color: '#1890ff' }}>{numberWithCommas(parseFloat(v || 0))} F</span> },
                                { title: 'Qté', dataIndex: 'qtCommander', key: 'qtCommander', align: 'center', render: v => <Tag color="blue" style={{ fontWeight: 700 }}>{v}</Tag> },
                                {
                                    title: 'Total HT', key: 'totalLigne', align: 'right',
                                    render: (t, r) => <span style={{ fontWeight: 700, color: '#52c41a' }}>{numberWithCommas(parseFloat(r.puUtilise || 0) * parseFloat(r.qtCommander || 0))} F</span>
                                },
                                { title: 'TVA', dataIndex: 'tauxTva', key: 'tauxTva', align: 'center', render: v => <Tag>{v ? `${v}%` : '0%'}</Tag> }
                            ]}
                            dataSource={listeArticlesSelected || []}
                            rowKey={(record, index) => index}
                            pagination={false}
                            bordered
                            size="small"
                        />
                    </div>

                    {/* RECAPITULATIF FINANCIER & TAXES */}
                    <AntRow gutter={[16, 16]}>
                        <AntCol xs={24} md={10}>
                            <Card
                                title={<span style={{ fontSize: 13, fontWeight: 700 }}>Groupe de Taxation & TVA</span>}
                                size="small"
                                bordered
                                style={{ borderRadius: 8, height: '100%' }}
                            >
                                <AntTable
                                    columns={[
                                        { title: 'Base HT', key: 'base', render: (t, r) => `${numberWithCommas(parseFloat(r.puUtilise || 0) * parseFloat(r.qtCommander || 0))} F` },
                                        { title: 'Taux', dataIndex: 'tauxTva', key: 'taux', align: 'center', render: v => `${v || 0}%` },
                                        { title: 'Montant TVA', key: 'montant', align: 'right', render: (t, r) => `${numberWithCommas((parseFloat(r.puUtilise || 0) * parseFloat(r.qtCommander || 0) * parseFloat(r.tauxTva || 0)) / 100)} F` }
                                    ]}
                                    dataSource={listeArticlesSelected || []}
                                    rowKey={(record, index) => index}
                                    pagination={false}
                                    size="small"
                                />
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 8px 4px', fontWeight: 600, fontSize: 13, borderTop: '1px solid #f0f0f0', marginTop: 8 }}>
                                    <span>Total TVA :</span>
                                    <span style={{ color: '#d46b08' }}>{numberWithCommas(parseFloat(totalTva || 0))} F CFA</span>
                                </div>
                            </Card>
                        </AntCol>

                        <AntCol xs={24} md={14}>
                            <Card
                                title={<span style={{ fontSize: 13, fontWeight: 700 }}>Récapitulatif Financier</span>}
                                size="small"
                                bordered
                                style={{ borderRadius: 8 }}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '4px 8px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Net HT :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(netHT || 0))} F CFA</span>
                                    </div>
                                    {parseFloat(montantRemise || 0) > 0 && (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#fa8c16' }}>
                                            <span>Montant Remise :</span>
                                            <span style={{ fontWeight: 600 }}>-{numberWithCommas(parseFloat(montantRemise || 0))} F CFA</span>
                                        </div>
                                    )}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Net Commercial :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(netCommercial || netHT || 0))} F CFA</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Total TVA :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(totalTva || 0))} F CFA</span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#595959' }}>
                                        <span>Montant TTC :</span>
                                        <span style={{ fontWeight: 600, color: '#262626' }}>{numberWithCommas(parseFloat(montantTtc || 0))} F CFA</span>
                                    </div>

                                    {/* GRAND BANDEAU NET A PAYER */}
                                    <div style={{
                                        background: 'linear-gradient(135deg, #f6ffed 0%, #e6f7ff 100%)',
                                        border: '1.5px solid #b7eb8f',
                                        borderRadius: 8,
                                        padding: '12px 16px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: 8
                                    }}>
                                        <div>
                                            <div style={{ fontSize: 11, color: '#52c41a', textTransform: 'uppercase', fontWeight: 700, letterSpacing: 0.5 }}>Net à Payer</div>
                                            <div style={{ fontSize: 11, color: '#8c8c8c' }}>{modRegl || 'Cash'} - {codmod || 'Espèces'}</div>
                                        </div>
                                        <div style={{ fontSize: 22, fontWeight: 800, color: '#389e0d', whiteSpace: 'nowrap' }}>
                                            {numberWithCommas(parseFloat(netaPayer || montFact || 0))} F CFA
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </AntCol>
                    </AntRow>
                </Modal>
            </div>
        );
    }
}


export default DetailsFactures;
